import { sync } from 'vuex-router-sync';
import router from '@/router';
import store from '@/store';

export default function () {
  sync(store, router);
}
